import { select } from '@ps/web-core-store';
import type { ResolvedIntlConfig } from 'react-intl';
import * as ReactIntl from 'react-intl';
import { useSelector } from 'react-redux';

export interface IntlProviderProps {
  children: React.ReactNode;
  messages?: ResolvedIntlConfig['messages'];
}

const IntlProvider: React.FC<IntlProviderProps> = ({ children, messages }) => {
  const intlLocale = useSelector(select.locale.getIntlLocale);

  return (
    <ReactIntl.IntlProvider locale={intlLocale} defaultLocale={intlLocale} messages={messages}>
      {children}
    </ReactIntl.IntlProvider>
  );
};

export default IntlProvider;
